import findByEntityAndActionMethod from './findByEntityAndActionMethod'

const mapEmails = (emails, mappedEmails) =>
  !emails.length
    ? []
    : mappedEmails.map(mappedEmail => {
        const email = findByEntityAndActionMethod(
          emails,
          mappedEmail.entity,
          mappedEmail.actionMethod,
        )

        return {
          ...email,
          mappedEmail,
        }
      })

export default mapEmails
